require('./bootstrap');
import 'bootstrap';
import { tns } from 'tiny-slider/src/tiny-slider';
import { masonry } from 'masonry-layout';
import { Carousel,Collapse } from 'bootstrap';

window.Collapse = Collapse;

var nav = document.querySelector('.navbar');
var body = document.querySelector('body');
var logo = document.getElementById('logo');

// Navigation

if(nav) {
  function hasClass(ele, cls) {
    return ele.classList.contains(cls);
  }

  function addClass(ele, cls) {
    if (!hasClass(ele, cls)) {
      ele.classList.add(cls);
    }
  }

  function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
      ele.classList.remove(cls);
    }
  }

  function lightenMenu() {
    removeClass(nav, 'bg-transparent');
    removeClass(nav, 'navbar-dark');
    addClass(nav, 'bg-white');
    addClass(nav, 'navbar-light');
    logo.src = '/img/linesight-logo-colored.svg';
  }

  function darkenMenu() {
    removeClass(nav, 'bg-white');
    removeClass(nav, 'navbar-light');
    addClass(nav, 'bg-transparent');
    addClass(nav, 'navbar-dark');

    if (window.outerWidth > 768) {
      logo.src = '/img/linesight-logo.svg';
    } else {
      logo.src = '/img/linesight-logo-colored.svg';
    }
  }

  if (hasClass(body, 'home')) {
    window.addEventListener('scroll', function () {
      var lastScrollTop = 0;
      var st = window.pageYOffset || document.documentElement.scrollTop;

      if (st > lastScrollTop && hasClass(nav, 'bg-transparent')) {
        lightenMenu();
      } else if (st == 0 && hasClass(nav, 'bg-white') && window.outerWidth > 768) {
        darkenMenu();
      }

      lastScrollTop = st <= 0 ? 0 : st;
    }, false);
  }
}

var myDropdown = document.getElementById('navigationMenu')
if(myDropdown) {
  myDropdown.addEventListener('show.bs.dropdown', function () {
    lightenMenu();
    document.querySelector('body').classList.add('nav-expanded');
  });

  myDropdown.addEventListener('hide.bs.dropdown', function () {
    document.querySelector('body').classList.remove('nav-expanded');
  });

  var myCollapsible = document.getElementById('navigationMenu')
  myCollapsible.addEventListener('show.bs.collapse', function () {
    lightenMenu();
    addClass(body, 'position-fixed');
  });

  myCollapsible.addEventListener('hide.bs.collapse', function () {
    lightenMenu();
    removeClass(body, 'position-fixed');
  });
}
// end of Navigation

// Tiny slider
// if (document.getElementById('projects-carousel')) {
//   var slider = tns({
//     container: '#projects-carousel',
//     items: 3,
//     slideBy: 'page',
//     autoplay: false,
//     nav: false,
//     autoplayButtonOutput: false,
//     loop: false,
//     controlsText: ['<img src="/img/prev.svg" alt="Previous slide">', '<img src="/img/next.svg" alt="Next slide">'],
//     responsive: {
//       0: {
//         items: 1,
//         gutter: 20,
//         fixedWidth: 282,
//         center: true
//       },
//       700: {
//         edgePadding: 25,
//         items: 2,
//         gutter: 28,
//         center: false,
//         fixedWidth: false
//       },
//       1000: {
//         edgePadding: 0,
//         items: 3
//       },
//       1900: {
//         gutter: 64
//       }
//     }
//   });
// }

// if (document.getElementById('sectors-carousel')) {
//   var slider = tns({
//     container: '#sectors-carousel',
//     items: 3,
//     slideBy: 'page',
//     autoplay: false,
//     nav: false,
//     autoplayButtonOutput: false,
//     loop: false,
//     controlsText: ['<img src="/img/prev.svg" alt="Previous slide">', '<img src="/img/next.svg" alt="Next slide">'],
//     responsive: {
//       0: {
//         items: 1,
//         gutter: 20,
//         fixedWidth: 282,
//         center: true
//       },
//       700: {
//         edgePadding: 25,
//         items: 2,
//         gutter: 28,
//         center: false,
//         fixedWidth: false
//       },
//       1000: {
//         edgePadding: 0,
//         items: 3
//       },
//       1900: {
//         gutter: 64
//       }
//     }
//   });
// }

// Locations Carousel
// if (document.getElementById('locations-carousel')) {
//   var slider = initializeLocationCarousel('#locations-carousel');
//   window.locationSlider = slider;
// }

// window.initializeLocationCarousel = initializeLocationCarousel;

// function initializeLocationCarousel(selector) {
//   return tns({
//     container: selector,
//     items: 3,
//     slideBy: 'page',
//     autoplay: false,
//     nav: false,
//     autoplayButtonOutput: false,
//     loop: false,
//     controlsText: ['<img src="/img/icon-round-left-primary.svg" alt="Previous slide">', '<img src="/img/icon-round-right-primary.svg" alt="Next slide">'],
//     responsive: {
//       0: {
//         items: 1,
//         gutter: 20
//       },
//       700: {
//         items: 2,
//         gutter: 10
//       },
//       900: {
//         items: 3
//       }
//     }
//   });
// }

// document.querySelectorAll('.employee-stories-carousel-container')
//   .forEach(function (containerEl) {
//     const carouselEl = containerEl.querySelector('.employee-stories-carousel');
//     const imgCarouselInstance = new Carousel(containerEl.querySelector('.employee-stories-imgs-carousel'));

//     carouselEl.addEventListener('slide.bs.carousel', function (e) {
//         if (e.direction == 'right') {
//           imgCarouselInstance.prev();
//         } else {
//           imgCarouselInstance.next();
//         }
//     });
//   });

document.querySelectorAll('.employee-stories-carousel-container')
  .forEach(function (containerEl) {
    const carouselEl = containerEl.querySelector('.employee-stories-carousel');
    const imgCarouselInstance = new Carousel(containerEl.querySelector('.employee-stories-imgs-carousel'));

    carouselEl.addEventListener('slide.bs.carousel', function (e) {
        if (e.direction == 'right') {
          imgCarouselInstance.prev();
        } else {
          imgCarouselInstance.next();
        }
    });
  });

// Click event listener
// var button = document.querySelector('#regionalReportsTabs .nav-item');

// button.addEventListener('click', event => {
//   // button.textContent = `Click count: ${event.detail}`;
//   addClass(button, 'nav-item-active');
// });

// document.addEventListener('click', function (event) {

//   // If the clicked element doesn't have the right selector, bail
//   if (!event.target.matches('#regionalReportsTabs .nav-item') ) return;

//   // Don't follow the link
//   event.preventDefault();

//   // Log the clicked element in the console
//   console.log(event.target);

// }, false);
